import { formatMoney, OrderCriteriaList } from '@nemuru-eng/js-api-client';

import { OrderCriteriaStatusTag } from '@/components/shared/components/OrderCriteriaStatusTag/OrderCriteriaStatusTag';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const orderStatusValueWithPrincipalAmountMobileFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.5,
    field: 'order_status_value',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData: { row: OrderCriteriaList['data'][0] }) => (
      <div style={{ minWidth: '120px' }}>
        <small>
          <OrderCriteriaStatusTag orderCriteria={rowData.row} />
        </small>
        <div color={palette.text.secondary}>
          <strong>{formatMoney(amountToValueMoneyMapper(rowData.row.loan.principal))}</strong>
        </div>
      </div>
    ),
  };
};
